import { StyleSheet } from "aphrodite";
import {
  fontSize,
  fontWeight,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";
import { space } from "main/javascripts/styles/base/spaceStyle";
import {
  accentColor,
  borderColor,
} from "main/javascripts/styles/base/colorStyle";
import { moreThanBreakpoint } from "main/javascripts/styles/base/responsiveStyle";

export interface IStyle {
  block: any;
  title: any;
}

export const BlockTitleStyle: IStyle = StyleSheet.create({
  block: {
    padding: space.atom,
  },
  title: {
    fontSize: fontSize.mediumHeading,
    lineHeight: lineHeight.headline1,
    color: accentColor.secondaryColor2,
    padding: space.atom,
    fontWeight: fontWeight.bold,
    letterSpacing: "0.1em",
    margin: "0.5rem 0",
    position: "relative",
    paddingBottom: space.atom2x,
    ":before": {
      content: "''",
      position: "absolute",
      bottom: 0,
      display: "block",
      height: "1px",
      width: `calc(100% - ${space.atom2x})`,
      background: borderColor.primaryLightColor,
    },
    ":after": {
      content: "''",
      position: "absolute",
      bottom: 0,
      display: "block",
      height: "1px",
      width: "3rem",
      background: accentColor.primaryColor,
    },
    [moreThanBreakpoint("tablet")]: {
      fontSize: fontSize.headline,
    },
  },
});
